import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { StarFilledIcon } from '@gemini/icons';
const Reviews = ({ reviews }) => {
    return (_jsx(Box, { alignItems: "center", display: "flex", children: _jsxs(Box, { alignItems: "start", display: "flex", marginRight: "spacing.8", children: [_jsx(StarFilledIcon, { color: "color.surface.decorative.yellow.default", marginRight: "spacing.8", size: "sizing.16" }), _jsxs(Box, { as: "span", typography: "typography.body.14.bold", children: [reviews.avgRating, "/5"] })] }) }));
};
export default Reviews;
